/* Surferelle trip hero
   - (i) button            -> opens the trip info drawer
   - button next to price  -> opens the booking/waitlist drawer for the viewer's combination
   - waitlist button stays disabled until "I agree to the terms" is ticked
   Vanilla JS, no jQuery needed. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function openDrawer(drawer) {
    if (!drawer || drawer.open) return;
    drawer.classList.remove('is-closing');
    drawer.showModal();
    document.body.classList.add('sft-lock');
  }

  function closeDrawer(drawer) {
    if (!drawer.open || drawer.classList.contains('is-closing')) return;
    var done = function () {
      drawer.classList.remove('is-closing');
      drawer.close();
      if (!document.querySelector('.sft-drawer[open]')) document.body.classList.remove('sft-lock');
    };
    if (reduceMotion.matches) return done();
    drawer.classList.add('is-closing');
    drawer.addEventListener('animationend', done, { once: true });
  }

  function setupTerms(scope) {
    scope.querySelectorAll('[data-sft-terms-gate]').forEach(function (gate) {
      var box = gate.querySelector('[data-sft-terms]');
      var target = gate.querySelector('[data-sft-terms-target]');
      if (!box || !target) return;
      var sync = function () {
        if (target.tagName === 'BUTTON') target.disabled = !box.checked;
        target.setAttribute('aria-disabled', String(!box.checked));
      };
      box.addEventListener('change', sync);
      target.addEventListener('click', function (e) { if (!box.checked) e.preventDefault(); });
      sync();
    });
  }

  function init(root) {
    if (root.dataset.sftReady) return;
    root.dataset.sftReady = 'true';

    var drawers = {};
    root.querySelectorAll('[data-sft-drawer]').forEach(function (d) {
      drawers[d.dataset.sftDrawer] = d;
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-sft-close]')) closeDrawer(d);
      });
      d.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(d); });
    });

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sft-open]');
      if (!trigger || !root.contains(trigger)) return;
      var drawer = drawers[trigger.dataset.sftOpen];
      if (!drawer) return; // no drawer -> the link works as a normal link
      e.preventDefault();
      openDrawer(drawer);
    });

    setupTerms(root);

    // After the waitlist form is sent the page reloads: show the confirmation straight away.
    if (drawers.action && drawers.action.querySelector('[data-sft-auto-open]')) openDrawer(drawers.action);
  }

  function initAll() { document.querySelectorAll('.sft').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll); // theme editor re-render
})();
